module.exports = __webpack_public_path__ + "img/defaultBook.1c43f4ad.png";